/*
 * @Description:
 * @Author: lz
 * @Date: 2021-06-16 09:49:32
 * @LastEditTime: 2021-06-26 15:51:34
 * @LastEditors: lz
 */
import { v4 as uuidv4 } from 'uuid';

// 判断当前环境
export function getEnvironmental() {
  var host = location.host;
  if (process && process.env.NODE_ENV === "development") {
    return "dev";
  } else if (host.indexOf("toGtest.gongsibao.com") > -1) {
    return "test";
  } else if (host.indexOf("toGstage.gongsibao.com") > -1) {
    return "stage";
  } else if (host.indexOf("toG.gongsibao.com") > -1) {
    return "prod";
  }
}

export function parseCnInlineTime(time) {
  if (time) {
    var date = new Date(time);
    var year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    // var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    // var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    return year + "年" + month + "月" + day + "日";
    // + ' ' + hours + ':' + minutes + ':' + seconds
  } else {
    return "";
  }
}

// 判断当前是什么浏览器
export function getSiteType() {
  var site_type = "";
  if (
    window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    site_type = "Mobile";
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      site_type = "WeChat";
    }
  } else {
    site_type = "PC";
  }
  return site_type;
}
// 判断是否是当前 年 月 日
export function getDateDiff(current, newStr) {
  let cy = current.getFullYear();
  let ny = newStr.getFullYear();
  let cm = current.getMonth();
  let nm = newStr.getMonth();
  let cd = current.getDate();
  let nd = newStr.getDate();
  return cy === ny && cm === nm && cd === nd;
}


// 写入DeviceId
export const setDeviceId = () => {
  let uuid = uuidv4()
  localStorage.setItem('device_id',uuid)
  return uuid
}

// 获取DeviceId
export const getDeviceId = () => {
  let u_id = localStorage.getItem('device_id')
  if(u_id) {
    return u_id
  }
  return setDeviceId()
}